/**
 * BlocPlus Public API Service
 * Fetches estate data from the public (no-auth) endpoint
 */

const BLOCPLUS_API = 'https://api.blocplus.com.au/api/v1';

export interface BlocPlusEstate {
  id: string;
  name: string;
  status: { id: string; code: string };
  availableLotsCount: number;
  totalLotsCount: number;
  geoLocation: { lat: number; lng: number };
  lots: BlocPlusLot[];
  references: BlocPlusReference[];
}

export interface BlocPlusStage {
  id: string;
  name: string;
  number: number;
  estimatedTitleDate?: string | null;
  titleStatus?: 'scheduled' | 'titled';
  releaseStatus?: 'future' | 'available';
  showPricePublicly?: boolean;
}

export interface BlocPlusLot {
  id: string;
  code: string;
  handleId: string;
  status: { id: string; code: string };
  price: string;
  landSize: number;
  frontage: number;
  points: { lat: number; lng: number }[];
  stage?: BlocPlusStage | null;
}

export interface BlocPlusReference {
  id: string;
  name: string;
  handleId: string;
  type: { id: string; code: string };
  points: { lat: number; lng: number }[];
}

/**
 * Fetch all public estates from BlocPlus (no authentication required)
 */
export async function fetchPublicEstates(): Promise<BlocPlusEstate[]> {
  const response = await fetch(`${BLOCPLUS_API}/estates/public`);

  if (!response.ok) {
    throw new Error(`BlocPlus API error: ${response.status}`);
  }

  return response.json();
}
